/**
 * Cómo se dibuja cada mensaje del hilo: como burbuja, como línea de evento o
 * no se dibuja (DEF-079, QA de TEST 12-oct-2026).
 *
 * POR QUÉ EXISTE
 * --------------
 * Cuando el cliente contesta una pregunta, la conversación guarda su mensaje
 * tal cual —«Soltero(a)», «A mi nombre»— y además cómo lo ENTENDIÓ el bot:
 * «[estado_civil] Soltero(a)», «[titularidad] A nombre del solicitante». Esa
 * anotación va con el remitente del cliente porque es una respuesta suya, y el
 * hilo la pintaba como una segunda burbuja del cliente debajo de cada
 * respuesta, con el identificador interno a la vista. No la escribió nadie, y
 * lo que dice ya está en la Ficha (el perfil declarado): no se dibuja.
 *
 * Las marcas del bot (`[flujo completado]`, `[durante atención humana: …]`) y
 * las del cliente que son una frase entera (`[declaró que el archivo es DNI]`)
 * van como línea de evento, separadas de lo conversado. Un adjunto
 * (`[document] DNI.pdf`) es lo que el cliente mandó: va en su burbuja, con la
 * tarjeta del archivo.
 *
 * Puro y sin imports: lo corre `tests/unit/test_qa_test_12oct_portal.py` en
 * Node, y cruza `TIPOS_DE_MEDIA` con `conversation/handler.TIPOS_DE_MEDIA`.
 */

export type ComoSeDibuja = 'burbuja' | 'evento' | 'nada'

/** Los tipos de media que la conversación guarda como `[tipo] archivo`. */
export const TIPOS_DE_MEDIA = ['document', 'image', 'audio', 'video', 'sticker']

export interface MensajeDelHilo {
  sender: string
  text?: string | null
  attachment?: unknown
}

export function comoSeDibuja(m: MensajeDelHilo): ComoSeDibuja {
  if (m.attachment) return 'burbuja'
  const t = (m.text || '').trim()
  if (!t.startsWith('[')) return 'burbuja'
  if (m.sender === 'agent') return t.endsWith(']') ? 'evento' : 'burbuja'
  if (m.sender !== 'user') return 'burbuja'
  const anotacion = /^\[([a-z_]+)\] \S/.exec(t)
  if (anotacion) return TIPOS_DE_MEDIA.includes(anotacion[1]) ? 'burbuja' : 'nada'
  return t.endsWith(']') ? 'evento' : 'burbuja'
}
